import * as Sentry from '@sentry/vue'

const getEnvironment = () => {
    const { host } = window.location
    const locations = {
        localhost: 'local-development',
        '0.0.0.0': 'local-development',
        'calc.linxfour.local': 'local-development',
        'calc-uat.linxfour.com': 'uat',
        'calc.linxfour.com': 'production',
    }
    return locations[host] || 'development'
}

const isLocalEnvironment = () => {
    return getEnvironment() === 'local-development'
}

const getEnvironmentConfig = () => {
    const env = getEnvironment()

    const configs = {
        'local-development': {
            debug: true,
            tracesSampleRate: 0.0,
            replaysSessionSampleRate: 0.0,
            replaysOnErrorSampleRate: 0.0,
        },
        uat: {
            debug: false,
            tracesSampleRate: 0.05,
            replaysSessionSampleRate: 0.05,
            replaysOnErrorSampleRate: 0.5,
        },
        production: {
            debug: false,
            tracesSampleRate: 0.01,
            replaysSessionSampleRate: 0.05,
            replaysOnErrorSampleRate: 0.5,
        },
    }

    return configs[env] || configs['local-development']
}

export function initializeSentry(app) {
    const env = getEnvironment()

    if (env !== 'production' && env !== 'uat') {
        if (isLocalEnvironment()) {
            console.log('Sentry disabled for local development')
        }
        return
    }

    const envConfig = getEnvironmentConfig()

    Sentry.init({
        app,
        dsn: 'https://9681ed4a72094a5aa73df4543888ba82@o1154930.ingest.sentry.io/6235004',
        integrations: [
            Sentry.browserTracingIntegration({
                instrumentNavigation: false,
                instrumentPageLoad: true,
            }),
            Sentry.replayIntegration({
                maskAllText: env === 'production',
                blockAllMedia: env === 'production',
            }),
            Sentry.breadcrumbsIntegration({
                console: true,
                dom: true,
                fetch: true,
                history: true,
                sentry: true,
                xhr: true,
            }),
        ],

        trackComponents: true,
        environment: env,

        ...envConfig,

        beforeSend(event, hint) {
            const error = hint?.originalException
            const message = event.message || event.exception?.values?.[0]?.value || ''

            if (
                message.includes('NetworkError') ||
                message.includes('Failed to fetch') ||
                message.includes('Load failed')
            ) {
                return null
            }

            if (message.includes('Loading chunk') || message.includes('Loading CSS chunk')) {
                return null
            }

            return event
        },

        beforeSendTransaction(event) {
            const transactionName = event.transaction || ''

            if (transactionName.includes('heartbeat') || transactionName.includes('health-check')) {
                return null
            }

            return event
        },
    })
}
